import { db, FirebaseDocRefType } from 'firebase/index'

const fetchEventRefs = (): Promise<FirebaseDocRefType[]> => {
  return db
    .collection('stores')
    .where('status', 'in', ['public', 'private'])
    .where('is_sacri_station', '==', true)
    .get()
    .then((snapshots) => {
      const refs: FirebaseDocRefType[] = []
      snapshots.forEach((snapshot) => refs.push(snapshot.ref))
      return refs
    })
}

export default fetchEventRefs
